import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTextField,
    _vm._g(
      _vm._b(
        {
          staticClass: "menu-search text-body-1",
          attrs: {
            height: "52px",
            dense: "",
            solo: "",
            flat: "",
            "hide-details": "",
          },
          scopedSlots: _vm._u([
            {
              key: "prepend-inner",
              fn: function () {
                return [_c(VIcon, [_vm._v("ui-icon-search")])]
              },
              proxy: true,
            },
          ]),
        },
        "v-text-field",
        { ..._vm.$attrs, ..._vm.$props },
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }